export const handleProfilePath = (currentPath) => {
	if (
		currentPath.includes('my-deposits') ||
		currentPath.includes('increase-limit')
	) {
		return true;
	}
	return false;
};
